import './discountButton.scss';

import { CSSProperties } from 'react';
import { MdDiscount } from 'react-icons/md';

import { useWebContext } from '@/resources/hooks/useWebContext';
import { ClientTypes } from '@/services/clients';

export function DiscountsButton({
  className,
  label = 'Descontos',
  style = {},
  onClick = () => {},
}: { className?: string; style?: CSSProperties; label?: string; onClick?: () => void } = {}) {
  const { order, setShowIdenfificationModal } = useWebContext();
  return (
    <button
      className={`btn ${className}`}
      style={style}
      type="button"
      onClick={() => {
        if (order?.client?.type === ClientTypes.ANONYMOUS) {
          setShowIdenfificationModal(true);
          return;
        }
        onClick();
      }}
    >
      {className?.includes('mobile') ? null : <MdDiscount className="pr-1" />}
      {label}
    </button>
  );
}
